import { isMainnet } from 'src/configs/Configs.env';

export const isBSCNetwork = (chainId: any) => {
    if (!chainId) return false;
    if (isMainnet) {
        return chainId === 56;
    }
    return chainId === 97;
};
